export default `@layer components {
	:host {
		display: inline-block;
		text-align: left;
		padding: 0.7em 0.8em;
		margin: 0.5em;
		overflow: auto;
		line-height: 1.4;
	}

	:host(:not([bio])) [part~="bio"] {
		display: none;
	}

	[part~="avatar"] {
		border-radius: 6px;
		vertical-align: top;
		margin: 0.6em;
	}

	[part~="icon"] {
		fill: currentColor;
		height: 1em;
		width: 1em;
		vertical-align: middle;
	}

	[part~="name"] {
		font-size: 1.6em;
	}

	[part~="bio"] {
		overflow: auto;
		padding-left: 1.4em;
		margin: 0.4em;
		border-left: 7px solid currentColor;
	}

	.clearfix::after {
		display: block;
		content: '';
		clear: both;
	}

	.float-left {
		float: left;
	}

	.inline-block {
		display: inline-block;
	}

	.color-inherit {
		color: inherit;
	}
}`;
